/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Print_Admin_Last_Seen_AgoInputs */

const vi_print_admin_last_seen_ago = /** @type {(inputs: Print_Admin_Last_Seen_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ping cuối: ${i?.minutes} phút trước`)
};

/**

* @param {Print_Admin_Last_Seen_AgoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_last_seen_ago = /** @type {((inputs: Print_Admin_Last_Seen_AgoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Last_Seen_AgoInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_last_seen_ago(inputs)
});